import { Fragment } from 'react';
import GridProduct from '../../products/product/grid-product';
import ListProduct from '../../products/product/list-product';
import { IListContentProps, ListProductReferrer } from '../interfaces/interfaces';
import { LIST_TO_GRID_ENDPOINT } from '../services/list-page-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';
import { TopPanel } from '../panels/top-panel';
import { BottomPanel } from '../panels/bottom-panel';
import { ProductsIOwnLoginPopup } from '../panels/products-i-own/login-popup';
import { CompareTypeEnum } from '../compare/compare-type-enum';

/**
 * Product list content.
 */
const ListContent = (props: IListContentProps) => {

    const dispatch = useAppDispatch();

    const layoutMode = useAppSelector(store => store.layoutMode);
    const loading = useAppSelector(store => store.loading);
    const isCompareVisible = useAppSelector(store => store.isCompareVisible);
    const compareType = useAppSelector(store => store.compareType);
    const compareServersDocIdList = useAppSelector(store => store.compareServersDocIdList);

    const gridClasses = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
    const listClasses = 'lg:grid-cols-1';
    const currentLayoutMode = props.width <= LIST_TO_GRID_ENDPOINT ? 'grid' : layoutMode;
    const buttonsABCDAbTest = useAppSelector(store => store.buttonsABCDAbTest);

    const products = props.products;
    const compareCallback = () => {
        dispatch(rootActions.main({
            isComparePopupVisible: true,
        }));
    };

    const superSaleAbTest = useAppSelector(store => store.superSaleAbTest);

    return (
        <>
            { props.hasPanels && <TopPanel width={ props.width } /> }

            {
                products && products.length > 0 &&
                <div className={`grid gap-12  ${ currentLayoutMode === 'grid' ? gridClasses : listClasses }`}>
                    {
                        products.map(item => {

                            let compareVisible = isCompareVisible;
                            if(compareVisible && compareType === CompareTypeEnum.SoundGridServers) {
                                compareVisible = compareServersDocIdList.includes(item.documentID);
                            }

                            return (
                                <Fragment key={ item.nodeID }>
                                    {
                                        currentLayoutMode === 'grid' &&
                                        <GridProduct
                                            product={ item }
                                            removeImgLink={ false }
                                            removeTitleLink={ false }
                                            isCompareVisible={ compareVisible }
                                            compareType={ compareType }
                                            compareCallback={ compareCallback }
                                            buttonsABCDAbTest={ buttonsABCDAbTest }
                                            referrer={ ListProductReferrer.ListPage }
                                            showSuperSaleBadge={ superSaleAbTest === 'yes' }
                                        />
                                    }

                                    {
                                        currentLayoutMode === 'list' &&
                                        <ListProduct
                                            product={ item }
                                            removeImgLink={ false }
                                            removeTitleLink={ false }
                                            isCompareVisible={ compareVisible }
                                            compareType={ compareType }
                                            compareCallback={ compareCallback }
                                            buttonsABCDAbTest={ buttonsABCDAbTest }
                                            referrer={ ListProductReferrer.ListPage }
                                            showSuperSaleBadge={ superSaleAbTest === 'yes' }
                                        />
                                    }
                                </Fragment>
                            )
                        })
                    }
                </div>
            }

            {
                (!products || products.length <= 0) &&
                <div className="text-center py-10">{ loading ? 'Loading...' : 'No results found...' }</div>
            }

            { props.hasPanels && <BottomPanel/> }

            <ProductsIOwnLoginPopup />
        </>
    )
};

export default ListContent;